"use strict";
var React = require("react");
function highlighter(id, color) {
    return {
        url: 'highlighter-for-' + id,
        filter: (React.createElement("filter", { id: "highlighter-for-" + id, key: "highlighter-for-" + id },
            React.createElement("feColorMatrix", { in: "SourceGraphic", type: "saturate", values: "0", result: "toHighlight" }),
            " ",
            React.createElement("feFlood", { floodColor: color, floodOpacity: "0.5", result: "highlight" }),
            React.createElement("feComposite", { in: "highlight", in2: "toHighlight", operator: "atop" })))
    };
}
exports.highlighter = highlighter;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGlnaGxpZ2h0ZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvS2FhdmlvL2ZpbHRlcnMvaGlnaGxpZ2h0ZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSw2QkFBK0I7QUFDL0IscUJBQTRCLEVBQUUsRUFBRSxLQUFLO0lBQ2pDLE1BQU0sQ0FBQztRQUNILEdBQUcsRUFBRSxrQkFBa0IsR0FBRyxFQUFFO1FBQzVCLE1BQU0sRUFBRSxDQUNBLGdDQUFRLEVBQUUsRUFBRSxrQkFBa0IsR0FBRyxFQUFFLEVBQUUsR0FBRyxFQUFFLGtCQUFrQixHQUFHLEVBQUU7WUFDN0QsdUNBQWUsRUFBRSxFQUFDLGVBQWUsRUFDbEIsSUFBSSxFQUFDLFVBQVUsRUFBQyxNQUFNLEVBQUMsR0FBRyxFQUFDLE1BQU0sRUFBQyxhQUFhLEdBQUc7O1lBQ2pFLGlDQUFTLFVBQVUsRUFBRSxLQUFLLEVBQUUsWUFBWSxFQUFDLEtBQUssRUFBQyxNQUFNLEVBQUMsV0FBVyxHQUFHO1lBQ3BFLHFDQUFhLEVBQUUsRUFBQyxXQUFXLEVBQUMsR0FBRyxFQUFDLGFBQWEsRUFBQyxRQUFRLEVBQUMsTUFBTSxHQUFFLENBQzFELENBQ1o7S0FDUixDQUFBO0FBQ0wsQ0FBQztBQVpELGtDQVlDIn0=


//////////////////
// WEBPACK FOOTER
// ./~/@wikipathways/pvjs/lib/Kaavio/filters/highlighter.js
// module id = 475
// module chunks = 0